/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { CommunicationApiConfiguration } from '../communication-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CmmAcceptanceRequestDtoDto } from '../models/cmm-acceptance-request-dto-dto';


/**
 * the Acceptance API
 */
@Injectable({
  providedIn: 'root',
})
export class AcceptanceService extends BaseService {
  constructor(
    config: CommunicationApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation acceptanceUpdate
   */
  static readonly AcceptanceUpdatePath = '/notification-definition/acceptance';

  /**
   * Create or update acceptance
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `acceptanceUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  acceptanceUpdate$Response(params: {
    body: CmmAcceptanceRequestDtoDto
  },
  context?: HttpContext

): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, AcceptanceService.AcceptanceUpdatePath, 'put');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * Create or update acceptance
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `acceptanceUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  acceptanceUpdate(params: {
    body: CmmAcceptanceRequestDtoDto
  },
  context?: HttpContext

): Observable<void> {

    return this.acceptanceUpdate$Response(params,context).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

}
